import BlogSection from './BlogSection';

export default BlogSection;
